import { LocalConnection } from "../../types";
import { useState, useMemo } from "react";

interface Props {
  selectedNode: any;
  localConnections: LocalConnection[];
  onClickConnection: (connection: LocalConnection) => void;
}

export default function LocalLawList({
  selectedNode,
  localConnections,
  onClickConnection,
}: Props) {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredConnections = useMemo(() => {
    if (!searchQuery) return localConnections;
    return localConnections.filter((connection) =>
      connection.target_law_name_detail
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  }, [localConnections, searchQuery]);

  return (
    <div className="bg-white bg-opacity-90 p-4 rounded-lg shadow w-full max-w-md mx-auto flex flex-col gap-4">
      <div className="flex flex-col gap-2 mb-3">
        <div className="flex flex-col gap-1">
          <h3 className="text-base font-semibold whitespace-nowrap">
            {selectedNode.law_name} {selectedNode.number} 관련 지자체 조례
          </h3>
          <span className="text-gray-500 text-sm">
            {filteredConnections.length}개의 결과
          </span>
        </div>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="지자체 조례 검색..."
          className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-emerald-300"
        />
      </div>
      <div className="flex flex-col gap-2 min-h-[100px]">
        {filteredConnections.map((connection) => (
          <div
            key={connection.id}
            className="p-3 bg-gray-100 rounded cursor-pointer hover:bg-emerald-50 transition-colors"
            onClick={() => onClickConnection(connection)}
          >
            <div className="font-bold">{connection.target_law_name_detail}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
